import axios from "axios";
import swal from "sweetalert2";
import { useTranslate } from "react-redux-multilingual";

const useGetNextShortcut = ({ setDataNextShortcut, setDisabled, posid = null, onSuccess = null }) => {
    const t = useTranslate();

    const getNextShorcut = async (categoryName, categoryId, fields = null, extraParams = null) => {
        const url = posid
            ? `${process.env.REACT_APP_API_URL}api/pos/raccourci_caisse/get_next/${posid}`
            : `${process.env.REACT_APP_API_URL}api/pos/raccourci_caisse/get_next`;

        let body = fields ? { type: categoryName, id: categoryId, fields } : { type: categoryName, id: categoryId };
        if (extraParams) body = { ...body, ...extraParams };

        await axios.post(url, body).then((response) => {
            if (!response.data.valid) {
                let interms = '';
                var keys = Object.keys(response.data.errors);
                for (var i = 0; i < keys.length; i++) {
                    interms += response.data.errors[keys[i]].join(',') + ',';
                }
                interms = interms.split(',');
                let messageError = '';
                interms.forEach(interm => messageError += t(interm) + '. ');
                messageError = messageError.replace('undefined', '');
                swal.fire(messageError, "", "error");
            } else {
                const orderedNextShortCut = response.data.next.sort((a, b) => {
                    if (a.position != null && b.position != null) return a.position - b.position;
                    if (a.position != null) return -1;
                    if (b.position != null) return 1;
                    const aName = a.affiche || a.fulcustom_name || a.article_name || '';
                    const bName = b.affiche || b.fulcustom_name || b.article_name || '';
                    return aName.localeCompare(bName);
                });
                setDataNextShortcut(orderedNextShortCut);
                if (onSuccess) onSuccess();
            }
        }).catch((error) => {
            if (error == 'end_session') return;
            let errorName = (error.response == undefined) ? 'unknowError' : (error.response.status == 403) ? 'forbiddenGeneral' : 'unknowError';
            swal.fire(t(errorName), "", "error");
        });

        setDisabled(false);
    };

    return getNextShorcut;
};

export default useGetNextShortcut;
